
window.toggleMenuMobile = function() {
    const body = document.getElementsByTagName('body')[0];
    const el = document.getElementById('paytCoverMenuMobile');
    const appTranslate = document.getElementById('appTranslaterMobile');
    const translateContMobileMenu = document.getElementById('mobileMenuTranslaterContainer');
    const translateContMobile = document.getElementById('translater-mobile');

    if(el.classList.contains('d-none')) {
        el.classList.remove('d-none');
        if(appTranslate) {
            translateContMobileMenu.appendChild(appTranslate);
        }
        body.style.overflow = 'hidden';
    } else {
        el.classList.add('d-none');
        if(appTranslate) {
            translateContMobile.prepend(appTranslate);
        }
        body.style.overflow = 'auto';
    }
};
